import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Passeios de Barco em Vilamoura · Charters Privados · Morningstar";
const DESC = "Passeios de barco privados em Vilamoura até 18 pessoas — meio-dia, pôr-do-sol, Benagil e Ilhas a Leste. Charters tripulados e com catering a partir da Marina de Vilamoura.";
const PATH = "/pt/passeios-de-barco-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.vilamouraBoatTrips;

export const Route = createFileRoute("/pt/passeios-de-barco-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Passeios de Barco · Vilamoura · Algarve",
        title: "Passeios de barco privados em Vilamoura a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Oito cruzeiros emblemáticos a partir da Marina de Vilamoura — meio-dia nas falésias, Gruta de Benagil, pôr-do-sol e dia completo no Algarve. Até 18 pessoas, totalmente tripulado e com catering.",
        ctaPrimary: "Ver passeios",
        ctaSecondary: "Falar com o concierge",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "passeios de barco vilamoura, passeios de barco algarve, barco vilamoura, passeio barco vilamoura, tours de barco vilamoura",
      altPath: { en: "/vilamoura-boat-trips", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Yacht Boat Trips from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Passeios de Barco Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});
